import { Injectable, EventEmitter, Output } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { BehaviorSubject } from 'rxjs';
import { Router } from '@angular/router';


@Injectable({
  providedIn: 'root'
})
export class AppAnalysisService {
  ChatBoxStatus = new BehaviorSubject(true);
  PublicURL:any
 
  constructor(private http: HttpClient, private route: Router) { 
  }
  @Output() headerPlanUpdate: EventEmitter<any> = new EventEmitter<any>();



  deleteLayer(layerid) {
    return this.http.post<any>(this.PublicURL.PublicURLPython + '/Api_map_analysis/deleteLayer', { "layerid": layerid })
      .pipe(map(data => {
        if (data) {
          this.headerPlanUpdate.emit(true)
        }
        return data;

      }))
  }

  createNewMap(mapid, map_name, map_desc, project_type, module) { // For a new map 
    return this.http.post<any>(this.PublicURL.PublicURLPython + '/Api_map_analysis/createUpdateMap', { "mapid": mapid, "map_name": map_name, "map_desc": map_desc, "project_type": project_type, "module": module })
      .pipe(map(data => {
        return data;
      }))
  
  }


}
 





